// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dfdb0d71","455":"bf9a5491","977":"d75cf9f7"}[chunkId] + ".chunk.js";
};